<template>
	<song-form :addition="true" @save="save" @cancel="cancel"></song-form>
</template>


<script>
	import SongForm from "../components/SongForm.vue"
	import axios from '../ConfiguredAxios.js'

	import { EventBus } from '../event-bus.js'

	export default {
		components: {
			SongForm
		},
		data() {
			return {
			}
		},
		methods: {
			save: function (data) {
				axios.post("/rest/v1/songs", data.data, {
					headers: {
						"Authorization": "PIN "+ data.pin
					}
				}).then(response => {
					let firstLang = Object.keys(data.data.lyrics)[0]
					this.$router.push("/songs/" + response.data + "/lyrics/" + firstLang)
					EventBus.$emit('SongAdded');
				}, (error) => {
					if (error.response.status === 401) {
						alert("Incorrect PIN.")
					} else {
						alert("Unknown error occurred.")
					}
				})
			},
			cancel: function () {
				this.$router.push("/")
			}
		}
	}
</script>
